<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="6" class="pb-0">
        <AutocompleteGrade v-model="grade" required dense outlined label="Khối" @change="gradeChanged" />
      </v-col>
      <v-col cols="6" class="pb-0">
        <AutocompleteClass
          v-model="classData"
          clear-icon="mdi-close"
          label="Lớp"
          outlined
          dense
          :filter="classsFilters"
          required
          class="required"
          :rules="[$rules.required]"
          @change="classChanged"
        />
      </v-col>
      <v-col cols="12" class="py-0">
        <AutocompleteTeacherCard
          v-if="!defaultTeacher || !defaultTeacher.id"
          ref="autoCompleteTeacherCard"
          v-model="teacher"
          label="Giáo viên chủ nhiệm"
          outlined
          dense
          class="required"
          :rules="[$rules.required, ...rules]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import { map, get } from 'lodash'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteClass,
    AutocompleteTeacherCard
  },
  props: {
    state: Boolean,
    defaultTeacher: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      grade: '',
      classData: null,
      teacher: null,
      rules: [
        value => {
          return (
            !this.classData ||
            !value ||
            !map(this.classData.headTeachers, 'id').includes(value.id) ||
            'Giáo viên này đã được phân công chủ nhiệm cho lớp trên'
          )
        }
      ]
    }
  },
  computed: {
    classsFilters() {
      return { grade: get(this.grade, 'id'), type: 'coreCurriculum' }
    }
  },
  methods: {
    classChanged(classData) {
      this.grade = get(classData, 'grade')
    },
    getData() {
      if (this.$refs.form.validate()) {
        return { classData: this.classData, teacher: this.teacher }
      }
      return null
    },
    resetData() {
      this.grade = ''
      this.classData = null
      this.teacher = null
    },
    gradeChanged(grade) {
      if (this.classData && grade && this.classData.grade.id !== grade.id) {
        this.classData = null
      }
      this.grade = grade
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  mounted() {
    this.$refs.form.reset()
  },
  watch: {
    state(state) {
      if (!state) {
        this.resetData()
        this.$refs.form.reset()
      }
    },
    classData: 'resetValidation',
    grade: 'resetValidation'
  }
}
</script>
